import { validationMessages } from "../common/validationMessages";
import * as Yup from "yup";
export interface WeekInfo {
  weekStartDate: string;   // ISO date string (YYYY-MM-DD)
  description: string;
  division: string;
}

export interface Manifest {
  id: number;
  dayOfWeek: number;            // 1 = Monday, etc.
  driverName: string | null;
  status: "PLANNING" | "ASSIGNED" | "COMPLETED" | string;
  carrierNumber: string | null;
  carrierName: string | null;
  trailerNumber: string | null;
  manifestType: string | null;
  turnDescription: string;
  turnNumber: string;
  routeNumber: string | null;
  teamRequired: "0" | "1";       // looks like backend sends string
  tractorNumber: string | null;
  driverId: number | null;
  division: string;
  weekStartDate: string;         // ISO date string
  dropCount: number;
}

export interface ManifestsByDay {
  [dayOfWeek: string]: Manifest[];
}

export const weekOptions = [
  { label: "Monday", value: "1" },
  { label: "Tuesday", value: "2" },
  { label: "Wednesday", value: "3" },
  { label: "Thursday", value: "4" },
  { label: "Friday", value: "5" },
  { label: "Saturday", value: "6" },
  { label: "Sunday", value: "7" },
]

export const teamRequiredOptions = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
]

export const turndropType = [
  { label: "Origin", value: "O" },
  { label: "Destination", value: "F" },
  { label: "Intermediate", value: "S" },
]

export interface CopyLaneToDayPayload {
  division: string;
  weekStartDate: string; // YYYY-MM-DD
  sourceDay: string;
  turnNumber: string;
  targetDay: string;
}

export interface CopyLaneToDayResponse {
  success: boolean;
  message?: string;
}


export interface CloneWeekPayload {
  division: string;
  sourceWeekStartDate: string;
  targetWeekStartDate: string;
  targetWeekDescription?: string;
  exclusions: CloneWeekExclusions[];
}

export interface CloneWeekExclusions {
  dayOfWeek: number;
  fromTime?: string;
  toTime?: string;
}
export interface CloneWeekResponse {
  success: boolean;
  message?: string;
}

export interface CreateLanePayload {
  division: string;
  weekStartDate: string;
  turnNumber: string;
  dayOfWeek: number;
  turnDescription?: string;
  manifestType?: string;
  carrierNumber?: string;
  carrierName?: string;
  trailerNumber?: string;
  tractorNumber?: string;
  driverName?: string;
  driverId?: string;
  routeNumber?: string;
  teamRequired?: boolean;
  notes?: string;
}

export interface CreateLaneResponse {
  success: boolean;
  message?: string;
}

export const createLaneValidationSchema = () => {
  return Yup.object({
    turnNumber: Yup.string().required(validationMessages.required),
    dayOfWeek: Yup.string().required(validationMessages.required),
  });
};

export interface CreateDropResponse {
  success: boolean;
  message?: string;
}

export interface CreateDropPayload {
  planId: string;
  terminalNumber: string;
  dropNumber: string;
  destinationDivision: string;
  earlyArrivalDate: string;
  earlyArrivalTime: string;
  earlyDepartureDate: string;
  earlyDepartureTime: string;
  miles: string;
  tractorNumber: string;
  notes: string;
}

export interface StaticLoadResponse {
  success: boolean;
  message?: string;
}

export interface BuildWeekPayload {
  division: string;
  weekStartDate: string;
}

export interface CreateWeekPayload {
  division: string;
  weekStartDate: string;
  weekDescription: string;
  scheduleType: string;
}

export const scheduleType = [
  { label: 'Master', value: 'MASTER' },
  { label: 'Working', value: 'WORKING' },
]

export const DAYS_OF_WEEK = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7
} as const;
